export const iconStyle = `
.component-Elements-Icon {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: inline-block;
    }
    .component-Elements-Icon .primary-bg {
        background-color: #a234b2;
    }
    .component-Elements-Icon .black-bg {
        background-color: black;
    }
    .component-Elements-Icon .white-bg {
        background-color: white;
    }
    .component-Elements-Icon .gray-bg {
        background-color: #f2f2f2;
    }
    .component-Elements-Icon .icon {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background-size: auto;
    }
    .component-Elements-Icon .facebook {
        background-image: url("https://d207ibygpg2z1x.cloudfront.net/image/upload/v1/icons/facebook.webp");
        background-size: contain;
    }
    .component-Elements-Icon .twitter {
        background-image: url("https://d207ibygpg2z1x.cloudfront.net/image/upload/v1/icons/twitter.webp");
        background-size: contain;
    }
    .component-Elements-Icon .instagram {
        background-image: url("https://d207ibygpg2z1x.cloudfront.net/image/upload/v1/icons/instagram.webp");
        background-size: contain;
    }
    .component-Elements-Icon .email {
        background-image: url("https://d207ibygpg2z1x.cloudfront.net/image/upload/v1/icons/email.webp");
        background-size: contain;
    }
    .component-Elements-Icon .question {
        background-image: url("https://d207ibygpg2z1x.cloudfront.net/image/upload/v1/icons/question.webp");
        background-size: contain;
    }
    .component-Elements-Icon .share-arrow {
        background-image: url("https://d207ibygpg2z1x.cloudfront.net/image/upload/v1/icons/shareArrow.webp");
        background-size: contain;
    }
    .component-Elements-Icon .dotdotdot {
        background: url("https://d207ibygpg2z1x.cloudfront.net/image/upload/v1572445960/reactionBarIcons/more-options.svg") center no-repeat;
        background-size: contain;
        border-radius: 0;
    }
    @media only screen and (max-width: 360px) {
    .component-Layout-Icon {
            width: 38px;
            height: 38px;
        }
    .component-Layout-Icon .icon {
            width: 38px;
            height: 38px;
        }
    }
    .component-Elements-Icon.small {
        width: 32px;
        height: 32px;
    }
    .component-Elements-Icon.small .icon {
        width: 32px;
        height: 32px;
    }
    .component-Elements-Icon.xsmall {
        width: 22px;
        height: 22px;
    }
    .component-Elements-Icon.xsmall .icon {
        width: 22px;
        height: 22px;
    }
    `;
